// extracted by mini-css-extract-plugin
export default {"info":"artist-about_info__IeoC","socialMedia":"artist-about_socialMedia_wYDoF","iconContainer":"artist-about_iconContainer_D9vlS","icon":"artist-about_icon_Tv9xK"};